import React from "react";

class confimationModel extends React.Component {
  render() {
    const ids = {
      theme: "ppi-project-theme",
      subtheme: "ppi-project-subtheme",
      name: "ppi-project-name",
      description: "ppi-project-description",
      accounting_article: "ppi-project-accounting-article",
      operation_number: "ppi-project-operation-number",
      prioriy: "ppi-project-priority",
      fctva: "ppi-project-fctva",
    };
    return (
      <form>
        <div className="field-label">
          <label className="label" style={{ width: "max-content" }}>
            Êtes-vous sûr de vouloir effectuer cette action ?
          </label>
        </div>
        <div className="columns">
          <div className="column">
            <button
              className={`button is-primary ${
                this.props.submitting ? "is-loading" : ""
              }`}
              onClick={(e) => this.props.handleConfirm(e, "0")}
            >
              Annuler
            </button>
            <button
              className={`button is-primary ${
                this.props.submitting ? "is-loading" : ""
              }`}
              onClick={(e) => this.props.handleConfirm(e, "1")}
            >
              confirmer
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default confimationModel;



// WEBPACK FOOTER //
// ./src/component/scenarii/common/ConfirmationModel.js